/**
 * @file Identity Filter Button Component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Avatar from '../global/Avatar';
import { AVATAR_SIZE_52 } from '../../constants/avatar-sizes';
import Badge from '../global/Badge';
import Button from '../global/Button';

class IdentityFilterButton extends Component {
  static propTypes = {
    selectedIdentity: PropTypes.shape({
      id: PropTypes.string,
      identity: PropTypes.shape({
        name: PropTypes.string,
      }),
      entitled_matched_photos: PropTypes.shape({
        total: PropTypes.number,
        records: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            thumbnail_urls: PropTypes.arrayOf(
              PropTypes.shape({
                width: PropTypes.width,
                height: PropTypes.height,
                url: PropTypes.string,
              }),
            ),
          }),
        ),
      }),
      matched_photos: PropTypes.shape({
        total: PropTypes.number,
      }),
    }),
    isSelected: PropTypes.bool,
    toggleIdentity: PropTypes.func.isRequired,
    badgeText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node),
    ]),
  };

  static defaultProps = {
    hiddenIdentities: [],
  };

  render() {
    const {
      selectedIdentity,
      isSelected,
      toggleIdentity,
      badgeText,
      children,
    } = this.props;

    return (
      <Button
        btnStyle="reset"
        key={selectedIdentity.id}
        onClick={() => toggleIdentity(selectedIdentity)}
        className={classNames({
          'entitled-photos-identity-filter': true,
          selected: isSelected,
        })}
      >
        <Avatar
          photo={selectedIdentity.identity.current_photo}
          size={AVATAR_SIZE_52}
        />
        <Badge
          badgeStyle="primary"
          round
          className="total-photos"
          badgeSize="sm"
        >
          {badgeText}
        </Badge>
        {children}
      </Button>
    );
  }
}

export default IdentityFilterButton;
